import {Component, OnDestroy, OnInit} from '@angular/core';
import {Subscription} from 'rxjs/Subscription';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {UsersService} from '../../services/users.service';
import {UserModel} from '../../models/user.model';

@Component({
  selector: 'lba-select-user',
  templateUrl: './select-user.component.html',
  styleUrls: ['./select-user.component.scss'],
})
export class SelectUserComponent implements OnInit, OnDestroy {

  searchStr: string = '';

  users: UserModel[];

  userName: string = 'Select user';

  subscription: Subscription;

  isLoaded: boolean = false;

  constructor(
    private activeModal: NgbActiveModal,
    private userService: UsersService,
  ) {
  }

  ngOnInit() {
    this.subscription = this.userService.getUsers()
      .subscribe((data: UserModel[]) => {
        this.isLoaded = true;
        // console.log(data);
        this.users = data;
      },
        error => {
          console.log(error);
          window.alert('Error: ' + error.message + ', error status: ' + error.status);
        });
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  closeModal() {
    this.activeModal.close();
  }

  selectUser(selectedObject: UserModel) {
    this.activeModal.close(selectedObject);
  }

}
